
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import MainMenu from "@/modules/chessparty/MainMenu";
import { jwtVerify } from "../../pagesUtils/jwt";
async function getServerSideProps(ctx) {
    try {
        await jwtVerify(ctx);
        return {
            redirect: {
                destination: "/chessparty/lobby",
                permanent: false,
            },
        };
    }
    catch {
        return {
            props: {},
        };
    }
}
export default MainMenu;

    async function __Next_Translate__getServerSideProps__1a042aa3d5b__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/chessparty/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a042aa3d5b__ as getServerSideProps }
  